<template>
  <div
    class="m-the-modal-shadow"
    @click.prevent="$modal.closeModal"
  >
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheModalShadow'
}
</script>
